export default () => {
  const data = {
    event_name: 'click',
    button_name: 'breadcrumb_country',
    page_section: 'card_section',
    name_of_the_page_viewed: 'search_personal',
  };
  return data;
};
